import { render, staticRenderFns } from "./ordered-list.vue?vue&type=template&id=353eb56d&functional=true&"
import script from "./ordered-list.vue?vue&type=script&lang=js&"
export * from "./ordered-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports